import { correlationHeaders } from "./correlation";

/**
 * Headers for LiveKit token-server routes that require Bearer telemetry JWT
 * (recording, presence, session join). Obtain JWT via TelemetryBootstrap.
 *
 * Correlation headers (`X-Request-Id`, and `X-Session-Id` when a session is
 * active) are folded in automatically (TI-316) so every VSS call is traceable.
 */
export function authJsonHeaders(telemetryJwt) {
  const h = { "Content-Type": "application/json" };
  if (telemetryJwt) {
    h.Authorization = `Bearer ${telemetryJwt}`;
  }
  return correlationHeaders(h);
}
